import { useLocation } from 'react-router-dom';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from 'react';
import './SearchPanel.css';
import { withRouter } from 'react-router-dom';

function SearchPanel(props) {
    const [searchText, setSearchText] = useState("");
    const location = useLocation();
    
    const params = new URLSearchParams(location.search);
    params.set("search", searchText);

    return (
        <div id="searchpanel">
            <form className="inner" 
                onSubmit={evt => {
                    evt.preventDefault(); 
                    props.history.push(`/groups/search?${params.toString()}`);
                }}
            >
                <div className="label">
                    {props.lang==="hu" ? "Keresés:" : "Search:"}
                </div>
                <div className="input">
                    <input 
                        type="search" 
                        name="search"
                        className="text-field"
                        value={searchText}
                        onChange={evt => setSearchText(evt.target.value)}
                    />
                </div>
                <button type="submit" className="search-button">
                    <FontAwesomeIcon icon={faSearch} size="lg"/>
                </button>
            </form>
        </div>
    );
}

export default withRouter(SearchPanel);
